import React from "react";
import { FaUserCog } from "react-icons/fa";

export default function AdminSettings() {
  return (
    <div style={{ maxWidth: "600px", fontFamily: "'Inter', sans-serif" }}>
      <h2 style={{ color: "#fff", marginBottom: "8px", fontSize: "24px" }}>Admin Global Settings</h2>
      <p style={{ color: "#94a3b8", marginBottom: "25px", fontSize: "14px" }}>Manage root configurations, platform security parameters, and node keys.</p>
      
      <div style={{ background: "rgba(30, 41, 59, 0.3)", padding: "30px", borderRadius: "20px", border: "1px solid rgba(255,255,255,0.05)" }}>
        <FaUserCog size={32} color="#38bdf8" style={{ marginBottom: "15px" }} />
        <h3 style={{ color: "#fff", margin: "0 0 10px" }}>System Version: 2.0.0</h3>
        <p style={{ color: "#94a3b8", fontSize: "13px", margin: 0 }}>All multi-tenant isolation layers and registry keys are running normally through MongoDB Atlas connection vectors.</p>
      </div>
    </div>
  );
}